export const findFirstChild = (children) => {
    if (children && children.length) {
        if (children[0].isLeaf) {
            return children[0];
        }
        else if (children[0].children && children[0].children) {
            findFirstChild(children[0].children);
        }
        else {
            return null;
        }
    }
    else {
        return null;
    }
};
